import React, { useEffect, useState } from "react";
import { Modal, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { format } from "date-fns";

const PublicCoupon = ({ show, onClose, page = 1, perPage = 10, searchTerm = "" }) => {
  const [coupons, setCoupons] = useState([]);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Get branch_id from localStorage
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10) || null;

  useEffect(() => {
    if (show) {
      fetchCoupons();
    }
  }, [show, page, perPage, searchTerm, branch_id]);

  const fetchCoupons = async () => {
    try {
      const response = await axios.get(`${baseURL}/coupon`, {
        params: { page, per_page: perPage, search: searchTerm, branch_id }
      });

      if (response.data?.data) {
        setCoupons(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      toast.error("Failed to fetch coupons");
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Coupon code copied!");
    });
  };

  return (
 <Modal show={show} size="lg" onHide={onClose}>
  <div className="modal-content">
    <div className="modal-header" style={{ backgroundColor: "#3ab384" }}>
      <h3 className="modal-title text-white">Public Coupons</h3>
      <button
        type="button"
        className="close px-6 py-1 btn btn-transparent"
        onClick={onClose}
      >
        <span className="text-white">×</span>
      </button>
    </div>

    {/* Make modal body scrollable */}
    <div
      className="modal-body"
      style={{ maxHeight: "400px", overflowY: "auto" }} // <-- Scrollable
    >
      <div className="table-container">
        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
          <thead>
            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
              <th className="min-w-100px text-start">Coupon / Code / Type</th>
              <th className="min-w-100px text-start">Amount</th>
              <th className="min-w-100px text-start">Start / End Date</th>
              <th className="min-w-60px text-end">Coupon Used</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-semibold fs-7">
            {coupons.length > 0 ? (
              coupons.map((coupon) => (
                <tr key={coupon.id}>
                  <td className="text-start">
                    <div className="d-flex flex-column">
                      <label className="text-black fw-bold fs-7">
                        {coupon.coupon_name || "-"}{" "}
                        <span className="badge bg-info text-white fs-8 mt-1 align-self-start">
                          {coupon.coupon_type === 0 ? "Welcome Offer" : "Recursion"}
                        </span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <label className="text-primary fs-8 mb-0">
                          <strong>{coupon.coupon_code || "-"}</strong>
                        </label>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Copy Coupon Code</Tooltip>}
                        >
                          <span
                            style={{ cursor: "pointer", color: "#0d6efd" }}
                            onClick={() => copyToClipboard(coupon.coupon_code)}
                          >
                            <i className="bi bi-clipboard"></i>
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </td>

                  <td className="text-start text-black">₹{coupon.coupon_value}</td>

                  <td className="text-start">
                    <label className="text-black fw-bold fs-7">
                      {format(new Date(coupon.startdate), "dd-MMM-yyyy")}
                    </label>{" "}
                    /{" "}
                    <label className="text-danger fw-bold fs-7">
                      {format(new Date(coupon.enddate), "dd-MMM-yyyy")}
                    </label>
                  </td>

                  <td className="text-end">-</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center text-danger fw-bold">
                  No coupons available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</Modal>

  );
};

export default PublicCoupon;
